import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicSignalContenUIllegal = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Sécurité et accessibilité', link: '/topics/securite'},
    { label: 'Signaler un problème', link: '/topics/securite/signal-probleme'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Wodzone permet aux utilisateurs et aux tiers de signaler tout contenu illégal présumé sur notre plateforme.
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">
                Vous pouvez signaler un contenu illégal présumé à l'aide de<a target='_blank' className="link" href="#">notre formulaire web.</a>
              </p>
              <p className="help-text">
                Pour faciliter notre examen du dossier, vous devrez fournir les informations suivantes :
              </p>
              <ul>
                <li className="pl-8 mb-16"><p className="help-text">Type d'illégalité suspectée</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Explication claire de l'emplacement exact du contenu illégal présumé</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Lien URL vers le contenu illégal présumé</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Explication suffisante et précise des raisons pour lesquelles vous considérez que le contenu enfreint la loi</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Documents justificatifs supplémentaires (comme des pièces jointes), le cas échéant</p></li>
              </ul>
              <p className="help-text">
                Lorsque vous envoyez votre signalement, vous devez également confirmer qu'il est envoyé de bonne foi, et que les informations sont exactes et complètes.
              </p>
              <p className="help-text">
                Une fois votre signalement envoyé :
              </p>
              <ul>
                <li className="pl-8 mb-16"><p className="help-text">Nous vous enverrons un e-mail pour confirmer que nous avons reçu votre signalement.</p></li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    Nous examinerons attentivement votre signalement, toutes les informations que vous envoyez et toutes les autres informations pertinentes dans le cadre de 
                    notre examen du dossier.
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">Nous vous enverrons par e-mail notre décision concernant votre signalement et inclurons toute autre option de recours à votre disposition.</p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    Si le signalement ne contient pas suffisamment d'informations pour que Wodzone puisse évaluer clairement si le contenu est illégal, 
                    il se peut que nous demandions plus d'informations ou que nous rejetions votre signalement
                  </p>
                </li>
              </ul>
              <p className="help-text">
                À noter que le contenu de votre signalement est destiné à un usage interne, mais il peut être transmis à l'utilisateur qui a publié le contenu signalé. 
                Nous traitons toutes les données personnelles conformément à notre<a target='_blank' className="link" href="/topics/about/62">Politique de confidentialité,</a>et l'identité 
                et toute donnée personnelle de l'utilisateur ayant envoyé le signalement ne sont divulguées que conformément à nos obligations légales.
              </p>
            </div>
            <div className="article-container mt-56">
              <p className="help-title-part">{topic.subtitles[1]}</p>
              <p className="help-text">
                Consultez nos<a target='_blank' className="link" href="#">Conditions de service</a>pour connaître les circonstances dans lesquelles Wodzone peut 
                suspendre le traitement des signalements de contenus illégaux envoyés par le biais ce formulaire web.
              </p>
            </div>  
            <div className="article-container mt-56">
              <p className="help-title-part">{topic.subtitles[2]}</p>
              <p className="help-text">
                Les parties qui ne sont pas satisfaites d'une décision de Wodzone à la suite d'un signalement de contenu illégal présumé peuvent faire appel 
                de cette décision avec le système d'appel de Wodzone. Ces parties peuvent également avoir le droit d'envoyer une plainte auprès d'un organisme 
                certifié de règlement extrajudiciaire des litiges de l'Union européenne.
              </p>
            </div>  
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicSignalContenUIllegal